'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OperateMain = /** @class */function () {
    function OperateMain() {
        this.headerDom = document.getElementById('kingshiper-header');
        this.secondaryHeaderDom = document.getElementById('kingshiper-secondary-header');
        this.footerDom = document.getElementById('kingshiper-footer');
        this.searchBoxDom = document.getElementById('search');
        this.operateDom = document.getElementById('operate');
        this.init();
    }
    OperateMain.prototype.init = function () {
        this.handleSearch();
        this.handleAnchor();
        this.handleFixed();
        this.handleArrow();
    };
    OperateMain.prototype.handleSearch = function () {
        var that = this;
        var inputBox = _tool2.default.$_select(this.searchBoxDom, '.help-input-box');
        var inputImgBox = _tool2.default.$_select(this.searchBoxDom, '.input-img-box');
        var inputDom = _tool2.default.$_select(this.searchBoxDom, '.search-input');
        var inputIcon = _tool2.default.$_select(this.searchBoxDom, '.input-icon');
        var searchBtn = _tool2.default.$_select(this.searchBoxDom, '.search-btn');
        var cloneInputValueDom = _tool2.default.$_select(this.searchBoxDom, '.clone-input-value');
        var clearBtn = _tool2.default.$_select(this.searchBoxDom, '.search-clear');
        var isSelectText = false;
        var timer;
        clearTimeout(timer);
        timer = setTimeout(function () {
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                cloneInputValueDom.innerText = inputVal;
            } else {
                cloneInputValueDom.innerText = '请输入关键词查找';
            }
        }, 50);
        inputBox.addEventListener('click', function (e) {
            inputDom.focus();
            inputIcon.classList.add('hide');
            searchBtn.classList.add('show');
            inputDom.classList.add('add-width');
            inputImgBox.classList.add('add-width');
            clearBtn.classList.remove('active');
            cloneInputValueDom.classList.add('hide');
            var inputVal = inputDom.value.trim();
            if (inputVal == '') {
                cloneInputValueDom.innerText = '';
            }
            var target = e.target;
            if (inputVal != '') {
                searchBtn.classList.add('active');
            } else {
                searchBtn.classList.remove('active');
            }
            if (searchBtn.contains(target)) {
                if (inputVal != '') {
                    that.confirmSearch({
                        inputDom: inputDom,
                        searchBtn: searchBtn,
                        clearBtn: clearBtn
                    });
                    document.body.click();
                } else {
                    that.resetTitleBox();
                }
            }
            e.stopPropagation();
        });
        inputDom.addEventListener('keyup', function (event) {
            var e = event || window.event;
            var inputVal = inputDom.value.trim();
            if (inputVal != '') {
                searchBtn.classList.add('active');
                if (e.keyCode === 13) {
                    that.confirmSearch({
                        inputDom: inputDom,
                        searchBtn: searchBtn,
                        clearBtn: clearBtn
                    });
                    document.body.click();
                }
            } else {
                clearBtn.click();
                searchBtn.classList.remove('active');
                if (e.keyCode === 13) {
                    that.resetTitleBox();
                }
            }
        });
        inputDom.addEventListener('select', function () {
            isSelectText = true;
        });
        document.addEventListener('click', function () {
            inputDom.blur();
            var timer;
            clearTimeout(timer);
            timer = setTimeout(function () {
                if (!isSelectText) {
                    inputIcon.classList.remove('hide');
                    searchBtn.classList.remove('show');
                    inputDom.classList.remove('add-width');
                    inputImgBox.classList.remove('add-width');
                    cloneInputValueDom.classList.remove('hide');
                    var inputVal = inputDom.value.trim();
                    if (inputVal != '') {
                        cloneInputValueDom.innerText = inputVal;
                        clearBtn.classList.add('active');
                    } else {
                        cloneInputValueDom.innerText = '请输入关键词查找';
                        clearBtn.classList.remove('active');
                    }
                }
                isSelectText = false; // 回到初始状态
            }, 50);
        });
        clearBtn.addEventListener('click', function (e) {
            /**
             * qq浏览器输入中文时keyup事件的表现和chrome浏览器不一样
             *
             * 例子:
             * ----chrome:敲w未敲空格选中字时,keyup可获取w字母
             * ----qq浏览器:敲w未敲空格选中字时,keyup获取的是空字符串
             *
             * 以上会导致qq浏览器一直调用清空事件clearBtn.click(),导致输入框失焦无法输入
             * 为了保证能继续输入,目前只能注释掉以下失焦的代码inputDom.blur()
             */
            // inputDom.blur() 
            inputDom.value = '';
            inputIcon.classList.remove('hide');
            searchBtn.classList.remove('show');
            clearBtn.classList.remove('active');
            that.resetTitleBox();
            inputDom.classList.remove('add-width');
            inputImgBox.classList.remove('add-width');
            cloneInputValueDom.classList.remove('hide');
            cloneInputValueDom.innerText = '请输入关键词查找';
            e.stopPropagation();
        });
    };
    OperateMain.prototype.confirmSearch = function (doms) {
        var that = this;
        doms.searchBtn.classList.remove('show');
        doms.searchBtn.classList.remove('active');
        doms.clearBtn.classList.remove('show');
        doms.clearBtn.classList.add('hide');
        that.resetTitleBox();
        var inputVal = doms.inputDom.value.trim();
        if (inputVal != '') {
            var flag_1 = false;
            var h1Doms = _tool2.default.$_selectAll(that.operateDom, '.h1');
            var h2Doms = _tool2.default.$_selectAll(that.operateDom, '.h2');
            var h3Doms = _tool2.default.$_selectAll(that.operateDom, '.h3');
            var h4Doms = _tool2.default.$_selectAll(that.operateDom, '.h4');
            var domArr = [h1Doms, h2Doms, h3Doms, h4Doms];
            for (var _i = 0, domArr_1 = domArr; _i < domArr_1.length; _i++) {
                var hDom = domArr_1[_i];
                hDom.forEach(function (item) {
                    var titleText = item.innerText;
                    if (!titleText.includes(inputVal)) {
                        item.classList.add('hide');
                    } else {
                        flag_1 = true;
                        var reg = new RegExp(inputVal, 'g');
                        var highlight = "<span>".concat(inputVal, "</span>");
                        var highlightStr = titleText.replace(reg, highlight);
                        item.children[0].innerHTML = highlightStr;
                        // 处理搜索前收起H2-H4，搜索后不显示的问题
                        var isMatchH1 = item.classList.contains('h1');
                        if (!isMatchH1) {
                            var arrowBtn = item.closest('.fold-range').previousElementSibling.children[1];
                            var hasFoldClass = arrowBtn.classList.contains('fold');
                            if (hasFoldClass) {
                                arrowBtn.click();
                            }
                        }
                    }
                });
            }
            if (!flag_1) {
                // 未搜索到内容，显示缺省图
                var emptyBox = _tool2.default.$_select(that.operateDom, '.empty-box');
                var operateTitleBox = _tool2.default.$_select(that.operateDom, '.operate-title-box');
                emptyBox.classList.add('show');
                operateTitleBox.classList.remove('show');
            }
        } else {
            alert('关键词不能为空！');
        }
    };
    OperateMain.prototype.resetTitleBox = function () {
        var that = this;
        var emptyBox = _tool2.default.$_select(that.operateDom, '.empty-box');
        var operateTitleBox = _tool2.default.$_select(that.operateDom, '.operate-title-box');
        emptyBox.classList.remove('show');
        operateTitleBox.classList.add('show');
        var h1Doms = _tool2.default.$_selectAll(that.operateDom, '.h1');
        var h2Doms = _tool2.default.$_selectAll(that.operateDom, '.h2');
        var h3Doms = _tool2.default.$_selectAll(that.operateDom, '.h3');
        var h4Doms = _tool2.default.$_selectAll(that.operateDom, '.h4');
        var domArr = [h1Doms, h2Doms, h3Doms, h4Doms];
        for (var _i = 0, domArr_2 = domArr; _i < domArr_2.length; _i++) {
            var hDom = domArr_2[_i];
            hDom.forEach(function (item) {
                item.classList.remove('hide');
                var titleText = item.innerText;
                item.children[0].innerHTML = titleText;
            });
        }
    };
    OperateMain.prototype.handleAnchor = function () {
        var that = this;
        var h1Doms = _tool2.default.$_selectAll(that.operateDom, '.h1');
        var h2Doms = _tool2.default.$_selectAll(that.operateDom, '.h2');
        var h3Doms = _tool2.default.$_selectAll(that.operateDom, '.h3');
        var h4Doms = _tool2.default.$_selectAll(that.operateDom, '.h4');
        var domArr = [h1Doms, h2Doms, h3Doms, h4Doms];
        for (var _i = 0, domArr_3 = domArr; _i < domArr_3.length; _i++) {
            var hDom = domArr_3[_i];
            hDom.forEach(function (item) {
                item.addEventListener('click', function () {
                    clearTimeout(timer);
                    var clearActiveDom = _tool2.default.$_selectAll(that.operateDom, '.clear-active');
                    clearActiveDom.forEach(function (cItem) {
                        return cItem.classList.remove('active');
                    });
                    item.classList.add('active');
                    var dataHref = item.children[0].getAttribute('data-href');
                    var aNameDom = document.getElementsByName(dataHref)[0];
                    window.scrollTo({
                        left: 0,
                        top: aNameDom.offsetTop - 92,
                        behavior: "smooth"
                    });
                    history.pushState(null, '', "#".concat(dataHref));
                });
            });
        }
        // 初始进入页面，获取哈希值自动滚动到相应位置
        // 一定要加定时器，不然定位会出错
        var timer = setTimeout(function () {
            that.gotoFixedPosition();
        }, 700);
        window.addEventListener('hashchange', function () {
            that.gotoFixedPosition();
        });
    };
    OperateMain.prototype.gotoFixedPosition = function () {
        var urlHash = window.location.hash;
        if (urlHash != '') {
            var targetName = urlHash.substring(1, urlHash.length);
            var targetDom = document.getElementsByClassName(targetName)[0];
            targetDom.click();
        }
    };
    OperateMain.prototype.handleFixed = function () {
        var that = this;
        window.addEventListener('scroll', function () {
            var operateLeft = _tool2.default.$_select(that.operateDom, '.operate-left-fixed');
            // 文档总高
            var documentH = document.body.clientHeight;
            // 当前元素到文档顶部距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var toDocumentH = operateLeft.offsetTop + scrollTop;
            // 当前元素高度
            var operateLeftH = operateLeft.offsetHeight;
            // 当前元素距离文档底部距离(挺准的~)
            var toDocumentBottomH = documentH - toDocumentH - operateLeftH;
            if (scrollTop >= 90 && toDocumentBottomH >= 490) {
                operateLeft.classList.add('fixed');
            } else {
                operateLeft.classList.remove('fixed');
            }
        });
    };
    OperateMain.prototype.handleArrow = function () {
        var that = this;
        var arrowDom = _tool2.default.$_selectAll(that.operateDom, '.arrow');
        arrowDom.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.stopPropagation();
                var hasFoldClass = item.classList.contains('fold');
                var dataFoldClass = item.getAttribute('data-fold-class');
                var foldRangeDom = _tool2.default.$_select(that.operateDom, ".".concat(dataFoldClass));
                if (!hasFoldClass) {
                    item.classList.add('fold');
                    foldRangeDom.classList.add('hide');
                } else {
                    item.classList.remove('fold');
                    foldRangeDom.classList.remove('hide');
                }
            });
        });
    };
    return OperateMain;
}();
exports.default = OperateMain;